import { faMobileAlt } from '@fortawesome/pro-solid-svg-icons/faMobileAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FlexGap, FlexAlign, FlexJustify, StackHorizontal } from '@ukpostbox/frontend-framework';
import { faCamera } from '@fortawesome/pro-solid-svg-icons/faCamera';
import { BatteryTypeEntryType } from '../../Types/ForwardingBatchTypes';
import { BatteryEntry } from './BatteryEntry';

function MetalBatteryWithEquipment(props: BatteryTypeEntryType) {
	return (
		<BatteryEntry
			name='metalBatteriesWithEquipment'
			media={
				<StackHorizontal
					gap={FlexGap.ExtraSmall}
					align={FlexAlign.Center}
					justify={FlexJustify.Center}
					extraClass='mb-lg'
				>
					<FontAwesomeIcon icon={faMobileAlt} size='3x' />
					<FontAwesomeIcon icon={faCamera} size='3x' />
				</StackHorizontal>
			}
			title='Packed With Equipment'
			description={[
				{ value: 'Batteries must not be inside device/installed in equipment' },
				{ value: 'Batteries must be in original manufacturer packaging' },
				{ value: 'Batteries must be for the device that they are shipped with' },
				{ value: 'Max 2 Packs per shipment', important: true },
			]}
			defaultSelected={props.defaultSelected}
			callBack={(state) => props.onChangeCallback(state)}
			complete={props.complete}
			readOnly={props.readOnly}
		/>
	);
}

export { MetalBatteryWithEquipment };
